var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShowing
    ? _c("b-progress", {
        staticClass: "center-progress",
        attrs: {
          type: "is-info",
          size: "is-small",
          value: _vm.progressValue,
          format: "percent",
          "show-value": "",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }